<template>
  <div>
    <section class="vue-preview w-full">
      <section class="list w-full" @click="onImageClick">
        <div class="scrollLeft text-center" @click="scrollLeft">
          <font-awesome-icon
            icon="arrow-left"
            class="fa-fw arrow-icon"
          ></font-awesome-icon>
        </div>

        <div class="inner-scroll">
          <div ref="scrollWindow" class="inner-inner-scroll">
            <span
              class="scroll-image-wrapper"
              v-for="(img, index) in imageList"
              :key="index"
            >
              <view-photo @click="handleViewClick(index)"></view-photo>
              <add-to-cart
                v-if="!displayGroupOnly"
                @click="handleAddToCart(img.id)"
              ></add-to-cart>
              <img
                v-long-press="handleLongPress"
                :src="img.thumbnailSrc"
                :data-index="index"
                style="backgroundsize: cover; z-index: 5"
                @contextmenu.prevent
              />
            </span>
          </div>
        </div>

        <div class="scrollRight text-center" @click="scrollRight">
          <font-awesome-icon
            icon="arrow-right"
            class="fa-fw arrow-icon"
          ></font-awesome-icon>
        </div>
      </section>
      <div class="pre-container" v-if="~currentIndex &amp;&amp; isShowPre">
        <header class="pre__header" style="background-color: #4b4a4a">
          <div>
            {{ currentIndex + 1 }}/{{ imageList.length }}
            <button
              @click="close"
              class="inline-flex items-center px-3 pt-2 pb-3 ml-3 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-gray-600 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700 transition ease-in-out duration-150"
            >
              Return to Results
            </button>
          </div>

          <section>
            <icon
              v-if="screenWidth > 640"
              type="zoomin"
              @click="zoomin"
              class="hover:text-white cursor-pointer p-2 mt-1 float-right"
            ></icon>
            <icon
              v-if="screenWidth > 640"
              type="zoomout"
              @click="zoomout"
              class="hover:text-white cursor-pointer mx-3 mt-1 p-2 float-right"
            ></icon>
            <button
              v-if="!displayGroupOnly"
              @click="handleAddToCart(imageList[currentIndex].id)"
              class="inline-flex items-center px-3 pt-2 pb-3 mr-3 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-teal-600 hover:bg-teal-500 focus:outline-none focus:border-teal-700 focus:shadow-outline-teal active:bg-teal-700 transition ease-in-out duration-150"
            >
              Add To Cart
            </button>
            <cart-button
              @click="gotoCart"
              class="float-right mt-0"
            ></cart-button>
          </section>
        </header>
        <div class="pre__content" @click.prevent.stop="close">
          <div class="prev" v-if="currentIndex" @click.prevent.stop="prevClick">
            <icon class="prev-icon" type="prev" />
          </div>
          <div
            class="next"
            v-if="currentIndex &lt; imageList.length-1"
            @click.prevent.stop="nextClick"
          >
            <icon class="next-icon" type="next"></icon>
          </div>
          <span
            ref="selectImg"
            :style="{
              cursor: cursorStyle,
              transform: `scale(${scaleRate}) rotate(${rotateRate}deg)`,
            }"
            @click.prevent.stop="imageClick"
            ><img
              ref="img"
              :src="imageList[currentIndex].src"
              @load="onImageLoad"
              @contextmenu.prevent
          /></span>
        </div>
        <div class="pre__footer" v-if="showFooter">
          <slot name="footer" :image="imageList[currentIndex]">
            <div class="footer">{{ imageList[currentIndex].name }}</div>
          </slot>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Icon from "@/components/ui/images/Icon";
import AddToCart from "@/components/outfitter/AddToCart";
import ViewPhoto from "@/components/outfitter/ViewPhoto";
import photo from "../../../mixins/photo";
import CartButton from "../../outfitter/CartButton";

const defaultOptions = {
  defaultWidth: "100px",
  defaultHeight: "75px",

  keyMap: {
    zoomin: "+",
    zoomout: "-",
    rotate: "r",
    prev: "ArrowLeft",
    next: "ArrowRight",
  },
};
export default {
  name: "VuePreviewer",
  props: {
    displayGroupOnly: {
      type: Number,
      default: 0,
    },
    images: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: "image",
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [photo],
  components: { CartButton, Icon, AddToCart, ViewPhoto },
  data() {
    return {
      inIframe: window.self !== window.top,
      currentIndex: -1,
      isShowPre: false,
      scaleRate: 1,
      rotateRate: 0,
      cursorStyle: "zoom-in",
      currentLocation: 0,
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    order: function () {
      return this.$store.getters["order/getOrder"];
    },

    imageList() {
      return this.normalizeImage(this.images, {
        sWidth: this.componentOptions.defaultWidth,
        sHeight: this.componentOptions.defaultHeight,
      });
    },
    componentOptions() {
      return {
        ...this.$global_vue_image_previewer_options,
        ...defaultOptions,
        ...this.options,
      };
    },
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
    };
  },
  destroyed() {},
  methods: {
    gotoCart() {
      this.$router.push({
        name: "cart",
        params: {
          slug: this.$route.params.slug,
          external: this.$route.params.external,
        },
      });
    },
    handleLongPress(e) {
      e.preventDefault && e.preventDefault();
      e.stopPropagation && e.stopPropagation();
      e.cancelBubble = true;
      e.returnValue = false;
      return false;
    },
    getPictureCount() {
      if (window.innerWidth <= 450) {
        return 1;
      }
      if (window.innerWidth <= 768) {
        return 2;
      }
      return 3;
    },
    getImageSize() {
      return window.innerWidth * 0.71;
      //358
    },
    scrollLeft() {
      this.currentLocation -= this.$refs.scrollWindow.clientWidth * 0.99;
      this.currentLocation =
        this.currentLocation < 0 ? 0 : this.currentLocation;
      this.$refs.scrollWindow.scrollTo({
        top: 0,
        left: this.currentLocation,
        behavior: "smooth",
      });
    },
    scrollRight() {
      this.currentLocation += this.$refs.scrollWindow.clientWidth * 0.99;
      this.$refs.scrollWindow.scrollTo({
        top: 0,
        left: this.currentLocation,
        behavior: "smooth",
      });
    },
    handleAddToCart(id) {
      this.$emit("addToCart", id);
    },
    handleViewClick(index) {
      this.currentIndex = +index;
      this.isShowPre = true;
      this.$nextTick(() => {
        this.$refs["selectImg"].focus();
      });
      this.$emit("select", this.imageList[this.currentIndex]);
    },
    onImageLoad() {
      const scrHeight = document.documentElement.clientHeight;
      const scrWidth = document.documentElement.clientWidth;
      const img = this.$refs.img;
      if (img) {
        const { width, height } = img.getBoundingClientRect();
        const dW = width / scrWidth;
        const dH = height / scrHeight;
        if (dW > 1 && dH > 1) {
          if (dW > dH) {
            img.style.width = `${scrWidth}px`;
          } else {
            img.style.height = `${scrHeight}px`;
          }
        } else if (dW > 1) {
          img.style.width = `${scrWidth}px`;
        } else if (dH > 1) {
          img.style.height = `${scrHeight}px`;
        }
      }
    },
    normalizeImage(imgs, { sWidth, sHeight }) {
      return imgs.map((img, idx) => {
        // only src source
        // if (typeof img === "string") {
        return {
          width: sWidth,
          height: sHeight,
          src: this.getS3Photo(
            img.s3_path,
            img.s3_filename,
            800,
            800,
            40,
            true
          ),
          thumbnailSrc: this.getS3Photo(
            img.s3_path,
            img.s3_filename,
            350,
            250,
            40,
            true
          ),
          name: `Image ${idx + 1}`,
          id: img.id,
        };
        // } else {
        //   return {
        //     width: img.width || sWidth,
        //     height: img.height || sHeight,
        //     src: img.src,
        //     thumbnailSrc: img.thumbnailSrc || img.src,
        //     name: img.name,
        //   };
        // }
      });
    },
    onImageClick({ target }) {
      if (target.nodeName === "IMG" || target.getAttribute("name") === "img") {
        this.currentIndex = +target.dataset["index"];
        this.isShowPre = true;
        this.$nextTick(() => {
          this.$refs["selectImg"].focus();
        });
        this.$emit("select", this.imageList[this.currentIndex]);
      }
    },
    zoomin() {
      this.scaleRate += 0.5;
    },
    zoomout() {
      this.scaleRate -= 0.25;
      this.scaleRate = Math.max(this.scaleRate, 0.25);
    },
    rotate() {
      this.rotateRate += 90;
    },
    toggleFullscreen() {
      const isFullscreen =
        document.fullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullscreenElement ||
        document.webkitFullscreenElement ||
        false;
      if (isFullscreen) {
        this.exitFullscreen();
      } else {
        this.enterFullscreen();
      }
    },
    exitFullscreen() {
      const el = document.documentElement;
      const rfs =
        el.cancelFullscreen ||
        el.webkitExitFullscreen ||
        el.mozCancelFullscreen ||
        el.exitFullscreen;
      if (rfs) {
        rfs.call(el);
      } else {
        console.error("Your browser seems doesn't support fullscreen");
      }
    },
    enterFullscreen() {
      const el = document.documentElement;
      const rfs =
        el.requestFullscreen ||
        el.webkitRequestFullscreen ||
        el.mozRequestFullscreen ||
        el.msRequestFullscreen;
      if (rfs) {
        rfs.call(el);
      } else {
        console.error("Your browser seems doesn't support fullscreen");
      }
    },
    imageClick() {
      if (this.cursorStyle === "zoom-in") {
        this.cursorStyle = "zoom-out";
        this.scaleRate += 0.5;
      } else {
        this.cursorStyle = "zoom-in";
        this.scaleRate -= 0.5;
      }
    },
    prevClick() {
      const selectImgClassList = (this.$refs["selectImg"] || {}).classList;
      if (this.currentIndex > 0) {
        selectImgClassList && selectImgClassList.add("select-img");
        this.currentIndex -= 1;
        this.resetRate();
        setTimeout(() => {
          selectImgClassList && selectImgClassList.remove("select-img");
        });
      }
    },
    nextClick() {
      const selectImgClassList = (this.$refs["selectImg"] || {}).classList;
      if (this.currentIndex < this.imageList.length - 1) {
        selectImgClassList && selectImgClassList.add("select-img");
        this.currentIndex += 1;
        this.resetRate();
        setTimeout(() => {
          selectImgClassList && selectImgClassList.remove("select-img");
        });
      }
    },
    close() {
      this.currentIndex = -1;
      this.isShowPre = false;
      this.resetRate();
      this.$emit("close");
    },
    resetRate() {
      this.scaleRate = 1;
      this.rotateRate = 0;
    },
  },
};
</script>

<style scoped>
.scrollRight {
  width: 4%;
  height: 227px;
  margin: 8px 1% 0 0;
  float: right;
  background-color: #505151;
  cursor: pointer;
  border: 1px solid #505151;
  border-radius: 0px 10px 10px 0px;
  -moz-border-radius: 0px 10px 10px 0px;
  -webkit-border-radius: 0px 10px 10px 0px;
}

.scrollLeft {
  width: 4%;
  height: 227px;
  margin: 8px 0 0 1%;
  float: left;
  background-color: #505151;
  cursor: pointer;
  border: 1px solid #505151;
  border-radius: 10px 0px 0px 10px;
  -moz-border-radius: 10px 0px 0px 10px;
  -webkit-border-radius: 10px 0px 0px 10px;
}

.scrollRight:hover,
.scrollLeft:hover {
  background-color: #333434;
}

.arrow-icon {
  color: #ffffff;
  margin-top: 100px;
}

.arrow-icon:hover {
  color: #cbc9c9;
}

.image-cart-button {
  color: #047857;
  cursor: pointer;
}

.image-cart-button:hover {
  color: #10b981;
}

.list {
  border: 1px solid #505151;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  height: 245px;
}
.inner-scroll {
  height: 235px;
  width: 90%;
  white-space: nowrap;
  overflow-x: hidden;
  overflow-y: hidden;
  float: left;
}
.inner-inner-scroll {
  width: 100%;
  overflow: auto;
}
.scroll-image-wrapper {
  position: relative;
  display: inline-block;
  margin: 8px 1%;
  width: 31%;
  height: 235px;
}
.scroll-image-wrapper img {
  width: 100%;
  max-height: 235px;
}

.link {
  margin-right: 8px;
  cursor: pointer;
  color: #20a0ff;
}
.pre-container {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: 0;
  background-color: #0e0e0e;
}
.pre__header {
  z-index: 1010;
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  width: calc(100% - 16px);
  padding: 8px;
  max-height: 10%;
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
}
.icon {
  font-size: 16px;
  cursor: pointer;
  margin-right: 8px;
  margin-top: 5px;
  padding: 4px;
  float: right;
  width: 26px;
  height: 26px;
}
.icon:hover {
  color: white;
}
.pre__footer {
  z-index: 1010;
  position: fixed;
  bottom: 0;
  display: flex;
  width: 100%;
  max-height: 10%;
  background-color: rgba(0, 0, 0, 0.3);
}
.pre__content {
  display: flex;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
  overflow: auto;
}
* {
  transition: all 0.3s ease;
}
.select-img {
  transition: rotate 0s ease;
}
.pre__content::-webkit-scrollbar {
  display: none;
}
.prev,
.next {
  cursor: pointer;
  z-index: 1010;
  position: fixed;
  color: white;
  font-size: 22px;
  border-radius: 10px;
  height: 200px;
  width: 35px;
  background-color: black;
}
.prev {
  left: 16px;
}
.next {
  right: 16px;
}
.next-icon,
.prev-icon {
  margin-top: 92px;
  margin-left: 6px;
}
.pre__footer {
  display: flex;
  justify-content: center;
  color: white;
  padding: 8px;
}

@media (max-width: 768px) {
  .scrollRight {
    width: 10%;
  }

  .scrollLeft {
    width: 10%;
  }

  .inner-scroll {
    width: 78%;
  }

  .scroll-image-wrapper {
    margin: 8px 1%;
    width: 49%;
    height: 235px;
  }

  .scroll-image-wrapper img {
    height: 100%;
    width: 100%;
  }
}

@media (max-width: 480px) {
  .scrollRight {
    width: 10%;
  }

  .scrollLeft {
    width: 10%;
  }

  .inner-scroll {
    width: 78%;
  }

  .scroll-image-wrapper {
    margin: 8px 2px;
    width: 100%;
    height: 235px;
  }

  .scroll-image-wrapper img {
    height: 100%;
    width: 100%;
  }
}
</style>
